// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.email-change-page {
    max-width: 1320px;
    margin: 40px auto;
    padding: 0 20px;
    font-family: 'Noto Sans KR', sans-serif;
}

.ecp-breadcrumb {
    font-size: 14px;
    color: #888;
    margin-bottom: 40px;
}

.ecp-breadcrumb .current {
    font-weight: 500;
    color: #333;
}

.ecp-main-title {
    font-size: 36px;
    font-weight: bold;
    margin-bottom: 60px;
}

.ecp-progress-indicator {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin: 80px auto;
    position: relative;
    max-width: 600px;
}

.ecp-progress-indicator::before, .ecp-progress-indicator::after {
    content: '';
    position: absolute;
    top: 12px;
    left: 0;
    height: 3px;
    background-color: #eee;
    width: 100%;
    z-index: 0;
}

.ecp-progress-indicator::after {
    background-color: #E84100;
    width: 0;
    z-index: 1;
    transition: width 0.3s ease-in-out;
}

.ecp-progress-indicator.step-2::after { width: 50%; }
.ecp-progress-indicator.step-3::after { width: 100%; }

.ecp-progress-indicator .step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #ccc;
    font-weight: 500;
    position: relative;
    z-index: 2;
    width: 200px;
}

.ecp-progress-indicator .step-item.active { color: #222; }

.ecp-progress-indicator .circle {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background-color: #eee;
    margin-bottom: 20px;
    border: 3px solid #eee;
    box-sizing: border-box;
    transition: background-color 0.3s, border-color 0.3s;
}

.ecp-progress-indicator .step-item.active .circle {
    background-color: #E84100;
    border-color: #E84100;
}

.ecp-step-container {
    max-width: 900px;
    margin: 40px auto;
}

.ecp-section-title {
    font-size: 24px;
    font-weight: 500;
    padding-bottom: 20px;
    border-bottom: 2px solid #222;
    margin-bottom: 0;
}

.ecp-form-row, .ecp-summary-row {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
}

.ecp-form-row label, .ecp-summary-row .label {
    flex-basis: 200px;
    padding: 20px;
    background-color: #f8f8f8;
    font-weight: 500;
}
.ecp-summary-row span:last-child {
     flex-grow: 1;
     padding: 20px;
}


.ecp-form-row input {
    flex-grow: 1;
    padding: 10px 20px;
    border: none;
    outline: none;
    font-size: 16px;
}

.ecp-actions {
    display: flex;
    justify-content: center;
    margin-top: 60px;
}

.ecp-actions.space-between {
    justify-content: space-between;
    align-items: center;
}

.ecp-confirm-btn-large {
    background-color: #E84100;
    color: white;
    padding: 20px 80px;
    border: none;
    border-radius: 5px;
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
}

.ecp-back-btn, .ecp-confirm-btn {
    padding: 15px 60px;
    font-size: 18px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
}
.ecp-back-btn {
    background-color: #222;
    color: white;
    border: none;
}
.ecp-confirm-btn {
    background-color: #E84100;
    color: white;
    border: none;
}

.ecp-step-container.centered-content {
    text-align: center;
    padding: 120px 0;
}
.ecp-final-title {
    font-size: 28px;
    font-weight: 500;
    margin-bottom: 20px;
}
.ecp-final-text {
    font-size: 16px;
    color: #555;
    margin-bottom: 40px;
}
.ecp-black-btn {
    background-color: #222;
    color: white;
    border: none;
    padding: 15px 60px;
    font-size: 18px;
    font-weight: bold;
    border-radius: 5px;
    cursor: pointer;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .email-change-page {
        margin: 20px auto;
    }

    .ecp-main-title {
        font-size: 28px;
    }

    .ecp-form-row label, .ecp-summary-row .label {
        flex-basis: 150px;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .email-change-page {
        padding: 0 15px;
        margin: 15px auto;
    }

    .ecp-breadcrumb {
        font-size: 12px;
        margin-bottom: 20px;
    }

    .ecp-main-title {
        font-size: 24px;
        margin-bottom: 30px;
    }

    .ecp-progress-indicator {
        display: none;
    }

    .ecp-section-title {
        font-size: 20px;
    }

    .ecp-form-row, .ecp-summary-row {
        flex-direction: column;
        align-items: flex-start;
    }

    .ecp-form-row label, .ecp-summary-row .label {
        flex-basis: auto;
        width: 100%;
        background-color: transparent;
        padding: 10px 0;
    }

    .ecp-form-row input {
        padding: 10px 0;
        width: 100%;
    }

    .ecp-summary-row span:last-child {
        padding: 10px 0;
        width: 100%;
    }

    .ecp-actions {
        flex-direction: column;
        gap: 10px;
        margin-top: 40px;
    }
    
    .ecp-actions.space-between {
        flex-direction: column-reverse;
    }

    .ecp-confirm-btn-large, .ecp-back-btn, .ecp-confirm-btn, .ecp-black-btn {
        width: 100%;
        padding: 15px;
        font-size: 16px;
    }
    
    .ecp-step-container.centered-content {
        padding: 60px 0;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/EmailChangePage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,QAAQ;IACR,UAAU;IACV,kCAAkC;AACtC;;AAEA,wCAAwC,UAAU,EAAE;AACpD,wCAAwC,WAAW,EAAE;;AAErD;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA,4CAA4C,WAAW,EAAE;;AAEzD;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,oDAAoD;AACxD;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;AACA;KACK,YAAY;KACZ,aAAa;AAClB;;;AAGA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,6BAA6B;QAC7B,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".email-change-page {\n    max-width: 1320px;\n    margin: 40px auto;\n    padding: 0 20px;\n    font-family: 'Noto Sans KR', sans-serif;\n}\n\n.ecp-breadcrumb {\n    font-size: 14px;\n    color: #888;\n    margin-bottom: 40px;\n}\n\n.ecp-breadcrumb .current {\n    font-weight: 500;\n    color: #333;\n}\n\n.ecp-main-title {\n    font-size: 36px;\n    font-weight: bold;\n    margin-bottom: 60px;\n}\n\n.ecp-progress-indicator {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    margin: 80px auto;\n    position: relative;\n    max-width: 600px;\n}\n\n.ecp-progress-indicator::before, .ecp-progress-indicator::after {\n    content: '';\n    position: absolute;\n    top: 12px;\n    left: 0;\n    height: 3px;\n    background-color: #eee;\n    width: 100%;\n    z-index: 0;\n}\n\n.ecp-progress-indicator::after {\n    background-color: #E84100;\n    width: 0;\n    z-index: 1;\n    transition: width 0.3s ease-in-out;\n}\n\n.ecp-progress-indicator.step-2::after { width: 50%; }\n.ecp-progress-indicator.step-3::after { width: 100%; }\n\n.ecp-progress-indicator .step-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: #ccc;\n    font-weight: 500;\n    position: relative;\n    z-index: 2;\n    width: 200px;\n}\n\n.ecp-progress-indicator .step-item.active { color: #222; }\n\n.ecp-progress-indicator .circle {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    background-color: #eee;\n    margin-bottom: 20px;\n    border: 3px solid #eee;\n    box-sizing: border-box;\n    transition: background-color 0.3s, border-color 0.3s;\n}\n\n.ecp-progress-indicator .step-item.active .circle {\n    background-color: #E84100;\n    border-color: #E84100;\n}\n\n.ecp-step-container {\n    max-width: 900px;\n    margin: 40px auto;\n}\n\n.ecp-section-title {\n    font-size: 24px;\n    font-weight: 500;\n    padding-bottom: 20px;\n    border-bottom: 2px solid #222;\n    margin-bottom: 0;\n}\n\n.ecp-form-row, .ecp-summary-row {\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid #eee;\n}\n\n.ecp-form-row label, .ecp-summary-row .label {\n    flex-basis: 200px;\n    padding: 20px;\n    background-color: #f8f8f8;\n    font-weight: 500;\n}\n.ecp-summary-row span:last-child {\n     flex-grow: 1;\n     padding: 20px;\n}\n\n\n.ecp-form-row input {\n    flex-grow: 1;\n    padding: 10px 20px;\n    border: none;\n    outline: none;\n    font-size: 16px;\n}\n\n.ecp-actions {\n    display: flex;\n    justify-content: center;\n    margin-top: 60px;\n}\n\n.ecp-actions.space-between {\n    justify-content: space-between;\n    align-items: center;\n}\n\n.ecp-confirm-btn-large {\n    background-color: #E84100;\n    color: white;\n    padding: 20px 80px;\n    border: none;\n    border-radius: 5px;\n    font-size: 20px;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.ecp-back-btn, .ecp-confirm-btn {\n    padding: 15px 60px;\n    font-size: 18px;\n    font-weight: bold;\n    border-radius: 5px;\n    cursor: pointer;\n}\n.ecp-back-btn {\n    background-color: #222;\n    color: white;\n    border: none;\n}\n.ecp-confirm-btn {\n    background-color: #E84100;\n    color: white;\n    border: none;\n}\n\n.ecp-step-container.centered-content {\n    text-align: center;\n    padding: 120px 0;\n}\n.ecp-final-title {\n    font-size: 28px;\n    font-weight: 500;\n    margin-bottom: 20px;\n}\n.ecp-final-text {\n    font-size: 16px;\n    color: #555;\n    margin-bottom: 40px;\n}\n.ecp-black-btn {\n    background-color: #222;\n    color: white;\n    border: none;\n    padding: 15px 60px;\n    font-size: 18px;\n    font-weight: bold;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .email-change-page {\n        margin: 20px auto;\n    }\n\n    .ecp-main-title {\n        font-size: 28px;\n    }\n\n    .ecp-form-row label, .ecp-summary-row .label {\n        flex-basis: 150px;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .email-change-page {\n        padding: 0 15px;\n        margin: 15px auto;\n    }\n\n    .ecp-breadcrumb {\n        font-size: 12px;\n        margin-bottom: 20px;\n    }\n\n    .ecp-main-title {\n        font-size: 24px;\n        margin-bottom: 30px;\n    }\n\n    .ecp-progress-indicator {\n        display: none;\n    }\n\n    .ecp-section-title {\n        font-size: 20px;\n    }\n\n    .ecp-form-row, .ecp-summary-row {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .ecp-form-row label, .ecp-summary-row .label {\n        flex-basis: auto;\n        width: 100%;\n        background-color: transparent;\n        padding: 10px 0;\n    }\n\n    .ecp-form-row input {\n        padding: 10px 0;\n        width: 100%;\n    }\n\n    .ecp-summary-row span:last-child {\n        padding: 10px 0;\n        width: 100%;\n    }\n\n    .ecp-actions {\n        flex-direction: column;\n        gap: 10px;\n        margin-top: 40px;\n    }\n    \n    .ecp-actions.space-between {\n        flex-direction: column-reverse;\n    }\n\n    .ecp-confirm-btn-large, .ecp-back-btn, .ecp-confirm-btn, .ecp-black-btn {\n        width: 100%;\n        padding: 15px;\n        font-size: 16px;\n    }\n    \n    .ecp-step-container.centered-content {\n        padding: 60px 0;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
